module.exports = __webpack_public_path__ + "static/media/1250-point-season.21b10bb6.png";